import { TrackJS } from 'trackjs'
import { sanitizeErrorForLog, sanitizeReduxActionForLog } from './sanitizeObjectForLog'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const trackJSMiddleware = () => (next: any) => (action: any) => {
  try {
    // log every action so they appear in the TrackJS telemetry timeline (but without payload, to avoid sensitive data)
    const sanitizedAction = sanitizeReduxActionForLog(action)

    // eslint-disable-next-line no-console
    console.log(sanitizedAction)

    return next(action)
  } catch (err) {
    const sanitizedError = sanitizeErrorForLog(err)

    if (TrackJS.isInstalled && TrackJS.isInstalled()) {
      TrackJS.track(sanitizedError)
    } else {
      // at least log it in console, so user can report what is seen there
      console.error(err)
    }
  }
}

export default trackJSMiddleware
